import React from "react";
import { Button } from "../ui/button";
import { ArrowRight, Sparkles } from "lucide-react";

const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/7224090e-fb57-4f5d-924e-aab3d13254dc/images/15be804dec21ad59e5f207bc5bc2e5f977d42f575e785599359e65b49a3e3f1e.png";

export const Hero = () => {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden border-b border-zinc-200/70 bg-[#FAFAFA] noise-bg"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 pt-20 pb-24 md:pt-28 md:pb-32 lg:pt-32 lg:pb-40">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-7 reveal">
            <div className="inline-flex items-center gap-2 rounded-full border border-zinc-200 bg-white/60 backdrop-blur px-3.5 py-1.5 mb-8">
              <Sparkles size={14} className="text-blue-700" />
              <span className="section-label !text-[11px]">For creators &amp; audience builders</span>
            </div>

            <h1 className="font-heading font-bold text-zinc-900 text-4xl sm:text-5xl lg:text-[5.25rem] leading-[1.02] tracking-[-0.04em]">
              Turn your audience{" "}
              <span className="italic font-light text-zinc-500">into</span>{" "}
              <span className="text-blue-700">revenue.</span>
            </h1>

            <p className="mt-8 max-w-xl text-zinc-600 text-lg md:text-xl leading-relaxed">
              I help creators build digital products tailored to their audience &mdash; products you can actually market, launch and sell. You stay focused on content, I handle the build.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <Button
                data-testid="hero-cta-primary"
                onClick={() => scrollTo("#contact")}
                className="group rounded-full bg-zinc-900 hover:bg-blue-700 text-white h-12 px-7 text-base font-medium transition-all duration-300 active:scale-[0.98]"
              >
                Start a conversation
                <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button
                data-testid="hero-cta-secondary"
                onClick={() => scrollTo("#services")}
                variant="ghost"
                className="rounded-full h-12 px-6 text-base font-medium text-zinc-900 hover:bg-zinc-100"
              >
                See what I do
              </Button>
            </div>

            <div className="mt-12 flex flex-wrap items-center gap-x-10 gap-y-4 text-sm text-zinc-500">
              <div className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                <span>Currently taking new partners</span>
              </div>
              <div className="hidden sm:block h-4 w-px bg-zinc-300" />
              <div>Revenue-split friendly</div>
            </div>
          </div>

          <div className="lg:col-span-5 reveal reveal-delay-2">
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden border border-zinc-200 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.25)]">
                <img
                  src={HERO_IMAGE}
                  alt="A clean, modern workspace representing focused product building"
                  className="w-full h-[420px] md:h-[520px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-zinc-900/10 to-transparent" />
              </div>

              <div
                data-testid="hero-floating-card"
                className="absolute -left-4 -bottom-6 md:-left-8 md:-bottom-8 bg-white border border-zinc-200 rounded-2xl shadow-lg p-5 max-w-[260px]"
              >
                <div className="text-xs uppercase tracking-[0.2em] font-semibold text-blue-700 mb-2">
                  How it works
                </div>
                <p className="text-sm text-zinc-700 leading-relaxed">
                  You bring the audience. I build the product. We split the revenue.
                </p>
              </div>

              <div className="absolute -top-4 -right-4 hidden md:flex h-20 w-20 rounded-2xl bg-zinc-900 text-white items-center justify-center font-heading text-3xl font-bold rotate-3">
                MS
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
